import { createFileRoute } from '@tanstack/react-router'
import { AdminRemovedCases } from '../features/admin'
import { currentUserQuery, removedCasesQuery } from '../features/admin/queries'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/removed')({
  ...adminRouteState,
  loader: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQuery())
    if (!me.is_superadmin) throw new Error('Only the Patchbay superadmin can view removed cases.')
    return context.queryClient.ensureQueryData(removedCasesQuery())
  },
  component: AdminRemovedCases,
})
